import type { IApiRole } from '@styluxinc/api-schema';
import { createContext } from 'react';
import { User } from './user';

export interface UserContextType {
  user: User;
  setViewAsRoles: (roles: IApiRole[]) => void;
}

export const UserContext = createContext<UserContextType | null>(null);
